export function getObjectProperty<T>(obj: Object, propertyName: string, defaultValue = undefined): T
{
    if (obj !== undefined && obj !== null && obj.hasOwnProperty(propertyName))
    {
        return <T>obj[propertyName];
    }
    else
    {
        return <T>defaultValue;
    }
}